import { render, staticRenderFns } from "./DepositModal.vue?vue&type=template&id=77865776"
import script from "./DepositModal.vue?vue&type=script&lang=js"
export * from "./DepositModal.vue?vue&type=script&lang=js"
import style0 from "./DepositModal.vue?vue&type=style&index=0&id=77865776&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e128dc07b65f661f3a32bbc83dd42e36/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports